export default {
    rest_point: "https://crm.copix.app"
}

